export default __webpack_public_path__ + "static/photo4usluge-3f8d9b073a772d09959ee821efbd2194.png";